import React, { FC } from 'react';

import Alert from '@mui/material/Alert';

interface ErrorMessageProps {
  message?: string;
}

const ErrorMessage: FC<ErrorMessageProps> = (props) => {
  let { message } = props;
  return (
    message && (
      <Alert severity="error" style={{ marginBottom: 10 }}>
        {message}
      </Alert>
    )
  );
};

export default ErrorMessage;
